/** Decimal hour (e.g. 9.75) → minutes from midnight. */
export function hourToMinutes(hour: number): number {
  return Math.round(hour * 60);
}

export function minutesToHour(minutes: number): number {
  return minutes / 60;
}

export interface FormatClockTimeOptions {
  /** Week grid style: `9a`, `9:45a` */
  compact?: boolean;
}

/** Format decimal hour as clock time — `9.75` → `9:45 AM`. */
export function formatClockTime(hour: number, options?: FormatClockTimeOptions): string {
  const totalMinutes = hourToMinutes(hour);
  const h24 = ((Math.floor(totalMinutes / 60) % 24) + 24) % 24;
  const minutes = ((totalMinutes % 60) + 60) % 60;
  const period = h24 >= 12 ? 'PM' : 'AM';
  const h12 = h24 % 12 || 12;
  const mm = String(minutes).padStart(2, '0');

  if (options?.compact) {
    const suffix = period === 'AM' ? 'a' : 'p';
    return minutes === 0 ? `${String(h12)}${suffix}` : `${String(h12)}:${mm}${suffix}`;
  }

  return `${String(h12)}:${mm} ${period}`;
}

export function formatTimeRange(
  startHour: number,
  endHour: number,
  options?: FormatClockTimeOptions,
): string {
  return `${formatClockTime(startHour, options)}–${formatClockTime(endHour, options)}`;
}
